const Technology = require("../../../entities/Technology");
const {TechnologyNames, TechnologyTypes, Age}  = require("../../Constants");

class Mine extends Technology {
    constructor(age, techName, scienceCost, workerCost, multiplier){
        super(
            age,
            Mine.GetType(),
            techName,
            scienceCost,
            workerCost,
            {
                playerStateAltering:
                    (playerState) => {
                        playerState.resourceProductionCalculationDelegate.push({
                            Source: this,
                            Action: () => this.GetWorkerCount() * multiplier,
                        });
                        playerState.resourceProductionDelegate.push({
                            Source: this,
                            Priority: multiplier,
                            Action: () => {
                                // Each worker produces one blue token worth `multiplier` resources.
                                // Limited by the blue bank; Priority makes higher-level cards produce first.
                                var produced = Math.min(this.GetWorkerCount(), playerState.blueBank);
                                this.AddContent("blueCubes", produced);
                            },
                        });
                        playerState.currentResourceCalculationDelegate.push({
                            Source: this,
                            Action: () => this.GetBlueCubeCount() * multiplier,
                        })
                    }
            }
        )
        this.multiplier = multiplier;
    }
    static GetType = () => TechnologyTypes.Production.Mine;
}

class Bronze extends Mine {
    constructor(){
        super(Bronze.GetAge(), Bronze.GetName(), 0, 2, 1)
    }

    static GetInstance = () => new Bronze();
    static GetAge = () => Age.AgeA;
    static GetName = () => TechnologyNames.Production.Bronze;
}

class Iron extends Mine {
    constructor(){
        super(Iron.GetAge(), Iron.GetName(), 5, 5, 2)
    }

    static GetInstance = () => new Iron();
    static GetAge = () => Age.Age1;
    static GetName = () => TechnologyNames.Production.Iron;
}

class Coal extends Mine {
    constructor(){
        super(Coal.GetAge(), Coal.GetName(), 7, 8, 3)
    }

    static GetInstance = () => new Coal();
    static GetAge = () => Age.Age2;
    static GetName = () => TechnologyNames.Production.Coal;
}

class Oil extends Mine {
    constructor(){
        super(Oil.GetAge(), Oil.GetName(), 9, 11, 5)
    }

    static GetInstance = () => new Oil();
    static GetAge = () => Age.Age3;
    static GetName = () => TechnologyNames.Production.Oil;
}

module.exports = {
    Bronze,
    Iron,
    Coal,
    Oil
}